<template>
  <div id="app">
    <Souzoku/>
  </div>
</template>

<script>
  import Souzoku from './components/Souzoku'

  export default {
    name : 'App',
    components : {
      Souzoku : Souzoku
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue